import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const TooltipClassName = `${CLASS_NAME_PREFIX}-tooltip`;
